import { uuid } from "vue-uuid";

export function getFilterOptions(columns, rows, rowDataExtractor = (row) => row) {
  return columns.reduce((result, curr) => {
    result[curr.field] = rows
      .map(row=> rowDataExtractor(row))
      .filter((row) => row[curr.field] !== null && row[curr.field] !== undefined)
      .reduce((acc, row) => {
        const currFilter = curr.config?.filter;
        let nameModifier = (row) => row[curr.field];
        let customCheck = null;
        if (typeof currFilter === "object") {
          nameModifier = currFilter.nameModifier || nameModifier;
          customCheck = currFilter.customCheck || null;
        }

        let options = row[curr.field];

        if (typeof currFilter?.optionsExtractor == 'function') { // to extract options from specific path
          options = currFilter?.optionsExtractor(row);
        }

        if (!Array.isArray(options)) {
          acc.push({
            id: uuid.v4(),
            rowId: row?.id || null,
            name: nameModifier(row),
            value: row[curr.field],
            customCheck,
          })
        } else {
          options.forEach(item => {
            acc.push({
              id: uuid.v4(),
              rowId: item?.id || null,
              name: item.name,
              value: item.name,
              customCheck,
            })
          })
        }
        return acc;
      }, [])
      .filter((el, index, list) => list.findIndex((match) => match.name === el.name) === index) // unique values
      .filter((el) => el.name !== null && el.name !== undefined);
    return result;
  }, {});
}

const stringFilterCheck = (entityValue, filterValue) => {
  return entityValue?.toString()?.toLowerCase() == filterValue?.toString()?.toLowerCase();
}
const arrayFilterCheck = (entityValue, filterValue) => {
  return !!entityValue?.toString().toLowerCase().some((item) => item?.value?.toString().toLowerCase().includes(filterValue?.toString()?.toLowerCase()));
}

// * filterObject.value is a original value, not the translated one
export function getFilteredRows(rows, inputFilters, rowDataExtractor = (row) => row ) {
  let filteredRows = rows;
  const filters = inputFilters || {};

  Object.keys(filters).forEach((key) => {
    const defaultFilterCheckCallback = (entity, filterObject) => {
      const currentFilterCheck = Array.isArray(entity)
        ? arrayFilterCheck
        : stringFilterCheck;

      return currentFilterCheck(entity, filterObject?.value);
    }

    const checkFunc = filters[key]?.customCheck || defaultFilterCheckCallback;

    if (filters[key]) {
      filteredRows = filteredRows.filter((_row) => {
        const row = rowDataExtractor(_row);
        return checkFunc(row[key], filters[key])
      });
    }
  });
  return filteredRows;
}

const getSearchParamValue = (value) => {
  if (Array.isArray(value)) {
    return value.map((item) => item?.value);
  } else if (typeof value === 'object' && value !== null) {
    return value?.value; // assuming it's an object with a value property
  } else {
    return value; // for primitive types
  }
}

export function getSearchParams(paramsObj = {}, payload) {
  const parsedParamsObj = paramsObj ? Object.entries(paramsObj)
    .reduce((acc, [key, value]) => {
      const val = value?.value;
      if (val) {
        const formattedVal = getSearchParamValue(val);
        acc[key] = formattedVal;
      }
      
      return acc;
    }, {}) : {};

  if (!payload?.column) return parsedParamsObj;

  return {
    ...parsedParamsObj,
    [payload.column.query_key || payload.column.field]: getSearchParamValue(payload.value),
  }
}